import { MessageCircle } from 'lucide-react';

const WHATSAPP_NUMBER = '905432115283';
const WHATSAPP_MESSAGE = encodeURIComponent('Merhaba, bilgi almak istiyorum.');

function getWhatsAppUrl() {
  const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
  if (isMobile) {
    return `https://wa.me/${WHATSAPP_NUMBER}?text=${WHATSAPP_MESSAGE}`;
  }
  return `https://web.whatsapp.com/send?phone=${WHATSAPP_NUMBER}&text=${WHATSAPP_MESSAGE}`;
}

export default function WhatsAppButton() {
  const handleClick = (e) => {
    e.preventDefault();
    window.open(getWhatsAppUrl(), '_blank', 'noopener,noreferrer');
  };

  return (
    <a
      href={`https://wa.me/${WHATSAPP_NUMBER}`}
      onClick={handleClick}
      data-testid="whatsapp-button"
      className="fixed bottom-20 left-5 z-[9998] w-14 h-14 bg-[#25D366] rounded-full flex items-center justify-center shadow-lg shadow-[#25D366]/30 hover:scale-110 transition-transform duration-300 group"
      aria-label="WhatsApp"
    >
      <MessageCircle className="w-7 h-7 text-white fill-white" />
      <span className="absolute left-full ml-3 px-3 py-1.5 bg-[#0B0E14] border border-white/10 text-white text-xs font-medium rounded-sm whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
        WhatsApp
      </span>
    </a>
  );
}
